/* @flow */

import React from 'react';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import IntlMessageComponent from 'components/formatters/intlMessage';

type ContactSuccessViewComponentProps = {
};

export default function ContactSuccessViewComponent(props: ContactSuccessViewComponentProps) {
  return (
    <React.Fragment>
      <Paper elevation={0}>
        <Box p={3}>
            <IntlMessageComponent id="contact.success.message" />
        </Box>
      </Paper>
    </React.Fragment>
  );
}
